// extracted by mini-css-extract-plugin
module.exports = {"loadingAnimation":"Loader_loadingAnimation__kJQxn","loading-animation":"Loader_loading-animation__1LRsI"};